<template>
  <div>
    <iframe class="fullscreen" :src="iframeUrl"></iframe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        iframeUrl: 'https://cloud.yixiaozhi.com/#/uni_modules/uni-im/pages/index/index'
      };
    },
    created() {
      var friendUid = this.$route.query.friendUid
      //user_id为好友id,externalUid为当前登录用户
      this.iframeUrl += '?user_id=' + friendUid;
    }
  };
</script>

<style>
  iframe.fullscreen{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// index.vue?506d4aa2